@if (tabs?.length) {
  <app-tabs
    [tabs]="tabs">
  </app-tabs>
}

<br>

  <app-data-grid
    [data]="gridData$ | async"
    [loading]="isLoading"
    [filterable]="true"
    [filter]="filter"
    (filterChange)="filterChange($event)"
    [sortable]="true"
    [sort]="sort"
    (sortChange)="sortChange($event)"
    [pageable]="true"
    [pageSize]="pageSize"
    [skip]="skip"
    (pageChange)="pageChange($event)"
    [height]="700">

    <app-data-grid-column
      field="patient_name"
      title="{{ 'patient' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>

    <app-data-grid-column
      field="status"
      title="{{ 'status' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <grid-dropdown-filter
          [filter]="filter"
          [data]="statusCategories"
          column="status"
          textField="name"
          valueField="value"
        ></grid-dropdown-filter>
      </ng-template>
      <ng-template appGridCellTemplate let-dataItem>
        {{getStatusTranslation(dataItem.status)}}
      </ng-template>
    </app-data-grid-column>

    <app-data-grid-column
      field="test_group"
      title="{{ 'test' | translate | titlecase }}"
      [sortable]="false"
      [filterable]="false">
    </app-data-grid-column>

    <app-data-grid-column
      field="status_changed"
      title="{{ 'statusChanged' | translate | titlecase }}"
      filter="date">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-date-filter
          [column]="column"
          [filter]="filter"
          [operators]="['gte', 'lte']">
        </app-grid-date-filter>
      </ng-template>
      <ng-template appGridCellTemplate let-dataItem>
        {{dataItem.status_changed | date: 'MM/dd/yyyy HH:mm:ss'}}
      </ng-template>
    </app-data-grid-column>

    @if (authService.isOfficeGroupAdmin) {
      <app-data-grid-command-column [width]="100">
        <ng-template appGridCellTemplate let-dataItem>
          <button
            class="dg-btn dg-btn--primary"
            (click)="restart(dataItem)">
            {{ 'restart' | translate | titlecase }}
          </button>
        </ng-template>
      </app-data-grid-command-column>
    }

  </app-data-grid>
